import * as S from './styles'

export default function Input({ ...props }) {
  return <S.InputContainer {...props} />
}
